import {
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    ClickAwayListener,
    FormControlLabel,
    FormGroup,
    Tooltip
} from "@mui/material";
import {Dispatch, MouseEvent, SetStateAction, useContext, useEffect, useState} from "react";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {IncludedMeasure, Measure, MeasureType} from "../../services/GreenLoanService";
import {MeasurePercentageInput} from "../MeasurePercentageInput";
import {MeasureAmountInput} from "../MeasureAmountInput";
import {GreenLoanContext} from "../App";

interface Props {
    measure: Measure
    setIsNewMeasureChecked: Dispatch<SetStateAction<boolean>>
}

export function MeasureCardToggleNew(props: Props) {
    const {
        measure,
        setIsNewMeasureChecked
    } = props
    const {currentYear} = useContext(GreenLoanContext)
    const {
        handleIncludedMeasureAdd,
        handleIncludedMeasureRemove,
        handleIncludedMeasureChange
    } = useContext(GreenLoanContext)
    const isOldImplementation = false
    const cutoffYear = currentYear - 3;

    const [tooltipOpen, setTooltipOpen] = useState<boolean>(false)
    const [isChecked, setIsChecked] = useState<boolean>(false)
    const [measureInputValue, setMeasureInputValue] = useState(100)

    function handleCheckChange(e: MouseEvent<HTMLOrSVGElement>) {
        const origin = e.target as Element
        const tagName = origin.tagName
        // Ignore clicks on tooltip
        if (tagName !== "svg" && tagName !== "path") {
            setIsChecked(!isChecked)
        }
    }

    function getIncludedMeasure(): IncludedMeasure {
        return {
            measureNumber: measure.measureNumber,
            measureType: measure.type,
            percentage: measure.type === MeasureType.PERCENTAGE ? measureInputValue : undefined,
            amount: measure.type === MeasureType.AMOUNT ? measureInputValue : undefined,
            isOldImplementation: isOldImplementation,
            implementationYear: null
        }
    }

    useEffect(() => {
        if (isChecked) {
            let includedMeasure = getIncludedMeasure();
            const successfulUpdate = handleIncludedMeasureChange(includedMeasure.measureNumber, includedMeasure)
            if (!successfulUpdate) {
                handleIncludedMeasureAdd(includedMeasure)
            }
            setIsNewMeasureChecked(true)
        } else {
            handleIncludedMeasureRemove(measure.measureNumber, isOldImplementation)
            setIsNewMeasureChecked(false)
        }

    }, [isChecked, measureInputValue])

    return (
        <Card sx={{
            boxShadow: "none"
        }}>
            <CardHeader onClick={(e: MouseEvent<HTMLDivElement>) => handleCheckChange(e)}
                        style={{
                            cursor: "pointer"
                        }}
                        title={
                            <FormGroup
                                style={{
                                    justifyContent: "space-between",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    pointerEvents: "none",
                                    flexWrap: "nowrap"
                                }}>
                                <FormControlLabel
                                    control={<Checkbox checked={isChecked} sx={{color: 'primary'}}/>}
                                    label={isOldImplementation ? `Gjort før ${cutoffYear}` : `Gjort siden ${cutoffYear}, eller skal gjøres`}
                                />
                                {isChecked && !isOldImplementation &&
                                    <ClickAwayListener onClickAway={() => setTooltipOpen(false)}>
                                        <Tooltip title={measure.description}
                                                 style={{pointerEvents: "auto"}}
                                                 sx={{
                                                     "&:hover": {
                                                         color: "success.main"
                                                     }
                                                 }}
                                                 arrow
                                                 open={tooltipOpen}
                                        >
                                            <HelpOutlineIcon onClick={() => setTooltipOpen(!tooltipOpen)}/>
                                        </Tooltip>
                                    </ClickAwayListener>
                                }
                            </FormGroup>
                        }
            />
            {isChecked && measure.type !== MeasureType.COMPLETE && <CardContent>
                {measure.type === MeasureType.PERCENTAGE &&
                    <MeasurePercentageInput value={measureInputValue}
                                            setValue={setMeasureInputValue}
                                            implementedText={isOldImplementation ? `Ble utført på andel av ${measure.areaDescription}`
                                                : `Skal utføres på andel av ${measure.areaDescription}`}
                    />}
                {measure.type === MeasureType.AMOUNT &&
                    <MeasureAmountInput unit={measure.unit} value={measureInputValue}
                                        setValue={setMeasureInputValue}/>}
            </CardContent>}
        </Card>
    )
}